import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { TranslateModule } from "@ngx-translate/core";
import { NgClass, NgIf } from "@angular/common";

@Component({
    selector: 'app-block-header',
    template: `<div [ngClass]="{'xSmallScreen':xSmallScreen}">
        <h2><ng-content></ng-content></h2>
        <span *ngIf="viewAll" (click)="onMoreClick()">{{'watch.content.ranking.view_all_btn' | translate }}<span class="icon icon-arrow-right" *ngIf="!xSmallScreen"></span></span>
    </div>`,
    styleUrls: ['./blockHeader.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf, TranslateModule]
})


export class BlockHeaderComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = []

    @Input() viewAll:boolean = true; // display the view all btn.
    // Responsive Variables
    xSmallScreen: boolean;
    // ---
    @Output() moreClick:EventEmitter<void>;
    
    constructor(
        private responsive: BreakpointObserver,
    ) { 
        this.moreClick = new EventEmitter<void>();
    }

    onMoreClick(){
        this.moreClick.emit()
    }

    ngOnInit(): void {
        this.subscriptions = [
            this.responsive.observe(Breakpoints.XSmall).subscribe((result) => {
                this.xSmallScreen = result.matches ? true : false;
            })
        ]
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe())
    }



}